module.exports = __webpack_public_path__ + "img/gscx.9438c63e.jpg";